import { CircularProgress, mergeClassnames } from '@heathmont/moon-core-tw';
import Img from '~/client/shared/images/Img';
import useLoyaltyControl from './hooks/useLoyaltyControl';

const LoyaltyControlContainer = () => {
  const { isSmall, progress, site, tierImgUrl } = useLoyaltyControl();

  return (
    <div
      className={mergeClassnames(
        'relative m-0 flex h-10 w-10 cursor-pointer items-center justify-center md:ml-2',
        isSmall && 'h-8 w-8',
      )}
      data-testid="loyalty-control"
    >
      <div
        className={mergeClassnames(
          'absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2',
          isSmall && 'h-8 w-8',
        )}
      >
        <CircularProgress value={progress} size={isSmall ? 'sm' : 'md'} />
      </div>
      <div
        className={mergeClassnames(
          'relative z-10 h-8 w-8 rounded-full bg-frieza',
          site === 'livecasino' && 'bg-krillin',
          isSmall && 'rem:h-[26px] rem:w-[26px]',
        )}
      >
        {tierImgUrl && (
          <Img alt=" " src={tierImgUrl} className="block h-full w-full" />
        )}
      </div>
    </div>
  );
};
export default LoyaltyControlContainer;
